import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { acrissGroupFormData, isEditAcrissGroupDrawer, isOpenAcrissGroupDrawer } from "Pages/OneWay/AcrissGroups/@signals"
import AcrissGroupDrawerName from "./Name"
import AcrissGroupDrawerAcriss from "./Acriss"
import AcrissGroupDrawerSubmit from "./Submit"


export default function AcrissGroupDrawer() {
	return <DrawerSeeker
		hideActions
		title={isEditAcrissGroupDrawer.value ? 'Edit Acriss Group' : 'New Acriss Group'}
		isOpen={isOpenAcrissGroupDrawer.value}
		controller={() => acrissGroupFormData.value = {}}
		successText="save"
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<AcrissGroupDrawerName />
			</Grid>

			<Grid item xs={12}>
				<AcrissGroupDrawerAcriss />
			</Grid>

			<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
				<AcrissGroupDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}
